import { render, staticRenderFns } from "./ScrollIcon.vue?vue&type=template&id=7aeaa04d&scoped=true"
import script from "./ScrollIcon.vue?vue&type=script&lang=js"
export * from "./ScrollIcon.vue?vue&type=script&lang=js"
import style0 from "./ScrollIcon.vue?vue&type=style&index=0&id=7aeaa04d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aeaa04d",
  null
  
)

export default component.exports